import React from 'react';

import { PAYLINE_EVENTS, getPaylineHtml, isExpectedPaylineOrigin } from '../../services/payline';

/*
 * Iframe du widget Payline, dimensionnée par son contenu.
 *
 * Les 12 écrans qui montaient le widget répétaient la même iframe avec une hauteur
 * EN DUR (800 px, 500 px sur un écran). Cette hauteur ne pouvait convenir aux deux
 * états du parcours : trop haute pour le formulaire carte, elle laissait un grand
 * vide blanc ; trop basse pour la page ACS du challenge 3DS, elle imposait un
 * ascenseur imbriqué. Le `srcDoc` étant notre propre document, il mesure sa hauteur
 * réelle et la poste ici (`PAYLINE_RESIZE`).
 *
 * Limite connue : la page ACS est une iframe tierce à l'intérieur du widget. On
 * suit la hauteur que Monext lui donne, pas celle de son contenu réel. Si Monext
 * la contraint, l'ascenseur reste, mais à l'intérieur de la zone ACS seulement.
 */

// Hauteur d'amorçage, avant le premier message. Assez pour le formulaire carte,
// afin d'éviter un saut visible au chargement.
const INITIAL_HEIGHT = 420;

class PaylineWidgetFrame extends React.Component {
  /* */
  static defaultProps = {
    maxHeight: 1600,
    minHeight: 260,
    options: {},
    title: 'Payline Payment Widget',
  };

  constructor(props) {
    super(props);

    this.state = { height: INITIAL_HEIGHT };
  }

  componentDidMount() {
    window.addEventListener('message', this.handleMessage);
  }

  componentDidUpdate(prevProps) {
    // Un nouveau jeton, c'est un nouveau parcours : sans cette remise à zéro, l'iframe
    // conserverait la hauteur de la page ACS du parcours précédent.
    if (prevProps.token !== this.props.token) {
      this.resetHeight();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage);
  }

  resetHeight() {
    this.setState({ height: INITIAL_HEIGHT });
  }

  handleMessage = (event) => {
    // Même contrôle d'origine que partout ailleurs : ce message pilote la mise en page,
    // pas un paiement, mais rien ne justifie de l'accepter de n'importe qui.
    if (!isExpectedPaylineOrigin(event.origin)) return;

    try {
      const msg = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

      if (!msg || msg.type !== PAYLINE_EVENTS.RESIZE) return;

      const height = Number(msg.data && msg.data.height);
      if (!height || Number.isNaN(height)) return;

      const { maxHeight, minHeight } = this.props;

      this.setState({ height: Math.min(Math.max(height, minHeight), maxHeight) });
    } catch (err) {
      // Message non JSON : ce n'est pas le nôtre.
    }
  };

  /* */
  render() {
    const { options, title, token } = this.props;
    const { height } = this.state;

    return (
      <iframe
        srcDoc={getPaylineHtml(token, options)}
        sandbox='allow-scripts allow-forms allow-same-origin'
        style={{ width: '100%', height: `${height}px`, border: 'none' }}
        title={title}
      />
    );
  }
}

export default PaylineWidgetFrame;
